export default {
  data: () => ({
    textField: '',
    selectType: ''
  }),
  mounted(){
    const queryString = this.$route.query;

    if (queryString.name){
      this.textField = queryString.name;
    }
    // if (queryString.type){
    //   this.selectType = queryString.type;
    // }
  },
  methods: {
    handleSearch(e){
      e.preventDefault();
      this.$router.push({ name: 'ProductCategory', query: { name: this.textField } });
    },
    handleResetData(){
      this.textField = null;
      this.dates = [];
      this.$router.push({ name: 'ProductCategory' });
    }
  }
};
